import { useQuery } from "@tanstack/react-query";
import { getUserBundlesForMapping } from "../services/get-user-bundles-for-mapping";

export function useUserBundlesForMapping(params: {
  phone?: string | null;
  email?: string | null;
}) {
  const enabled = !!(params.phone || params.email);
  return useQuery({
    queryKey: ["user-bundles-for-mapping", params.phone, params.email],
    queryFn: () =>
      getUserBundlesForMapping({
        phone: params.phone ?? undefined,
        email: params.email ?? undefined,
      }),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
}
